export default __webpack_public_path__ + "static/media/icon_heart_fill.a0e78c56.svg";